<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'EmployeeAdvance_Title' | translateWF: 'Employee advances' }}</h1>
        @if (canPay) {
          <div class="page__title_buttons">
            <p-button [label]="'EmployeeAdvance_New' | translateWF: 'New advance'" icon="pi pi-plus" (click)="createAdvance()" />
          </div>
        }
      </div>
      <p class="text-sm text-[var(--p-text-muted-color)]">
        {{ 'EmployeeAdvance_Subtitle' | translateWF: 'Cash Treasury hands an employee for an open trip; the trip’s settlement nets it against the claims.' }}
      </p>
    </div>

    <div class="cs-page-list-grid">
      @if (showFilters() && filterConfig(); as config) {
        <div>
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'EmployeeAdvance_Title' | translateWF: 'Employee advances'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="items()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="number" style="width: 14rem">
                  {{ 'EmployeeAdvance_Col_Number' | translateWF: 'Number' }}
                  <p-sortIcon field="number" />
                </th>
                <th pSortableColumn="employee">
                  {{ 'EmployeeAdvance_Field_Employee' | translateWF: 'Employee' }}
                  <p-sortIcon field="employee" />
                </th>
                <th>{{ 'EmployeeAdvance_Field_Trip' | translateWF: 'Trip' }}</th>
                <th pSortableColumn="date" style="width: 9rem">
                  {{ 'EmployeeAdvance_Field_Date' | translateWF: 'Date' }}
                  <p-sortIcon field="date" />
                </th>
                <th pSortableColumn="amount" class="text-right" style="width: 11rem">
                  {{ 'EmployeeAdvance_Field_Amount' | translateWF: 'Amount' }}
                  <p-sortIcon field="amount" />
                </th>
                <th class="text-right" style="width: 11rem">{{ 'EmployeeAdvance_Outstanding' | translateWF: 'Still to net' }}</th>
                <th pSortableColumn="status" style="width: 9rem">
                  {{ 'Status' | translateWF: 'Status' }}
                  <p-sortIcon field="status" />
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let row = getRow(rowData);
              <tr>
                <td>
                  <a class="cs-table-link font-mono" (click)="redirectToDetails(row.id)">{{ row.number }}</a>
                </td>
                <td>{{ row.employee.name }}</td>
                <td>{{ tripsOf(row) }}</td>
                <td>{{ row.advanceDate | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                <td class="text-right tabular-nums">{{ symbolOf(row.currency) }} {{ row.amount | number: '1.2-2' }}</td>
                <td class="text-right tabular-nums">{{ symbolOf(row.currency) }} {{ row.outstanding | number: '1.2-2' }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status)" />
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center">{{ 'EmployeeAdvance_Empty' | translateWF: 'No employee advances found.' }}</td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
